import { GeneralsMealPreferencesMealType } from "@/clients/models/GeneralsMealPreferencesMealType";
import { MealPreferencesService } from "@/clients/services/MealPreferencesService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useUpdateMealTypePreference = () => {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, isError, error } = useMutation({
    mutationKey: [QueryKeys.MEAL_TYPE_PREFERENCE_LIFESTYLE],
    mutationFn: async (mealTypePreference: GeneralsMealPreferencesMealType) => {
      const user = guardGetUserFromLocalStorage();
      if (!user) {
        throw new Error("User not found");
      }

      const response =
        await MealPreferencesService.updateGeneralMealTypePreferenceApiV1MealPreferencesGeneralMealTypePreferencePut(
          user.id,
          mealTypePreference,
        );

      return response.data;
    },
    onSuccess: () => {
      // Invalidate and refetch the meal type preference query
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.MEAL_TYPE_PREFERENCE_LIFESTYLE],
      });
    },
  });

  return {
    updateMealTypePreference: mutate,
    updateMealTypePreferenceAsync: mutateAsync,
    isUpdating: isPending,
    isError,
    error,
  };
};
